import React from "react";

const FormToggle = ({
  label,
  description,
  name,
  checked,
  onChange,
  disabled = false,
  className = "",
  ...props
}) => {
  const id = `form-toggle-${name}`;
  
  return (
    <div className={`flex items-start ${className}`}>
      <div className="flex items-center h-5">
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={checked || false}
          onChange={onChange}
          disabled={disabled}
          className="
            h-4 w-4 rounded 
            text-primary-600 
            focus:ring-primary focus:ring-2 focus:outline-none
            border-gray-300
          "
          {...props}
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor={id} className="font-medium text-gray-700">
          {label}
        </label>
        {description && (
          <p className="text-gray-500">{description}</p>
        )}
      </div>
    </div>
  );
};

export default FormToggle;